<template>
  <footer class="site-footer">
    <div class="site-shell site-footer__main">
      <div class="site-footer__identity">
        <div class="footer-brand">
          <img src="@/assets/logo.png" alt="玉雕匠人">
          <div>
            <strong>玉雕匠人</strong>
            <span>JADE ARTISAN</span>
          </div>
        </div>
        <p>以专业记录匠心，让每一件玉雕作品都拥有清晰、可信的文化档案。</p>
      </div>

      <div class="site-footer__nav">
        <p class="site-footer__label">浏览</p>
        <div class="footer-links">
          <router-link to="/masters">匠人名录</router-link>
          <router-link to="/gallery">作品鉴赏</router-link>
          <router-link to="/news">行业资讯</router-link>
          <router-link to="/certificate">证书查询</router-link>
          <router-link to="/about">关于我们</router-link>
        </div>
      </div>

      <div class="site-footer__statement">
        <p class="site-footer__label">平台宗旨</p>
        <strong>识玉 · 懂艺 · 敬匠心</strong>
        <p>传承玉雕技艺，连接匠人与收藏者。</p>
      </div>
    </div>

    <div class="site-footer__bottom">
      <div class="site-shell">
        <span>&copy; 2026 玉雕匠人 版权所有</span>

      </div>
    </div>
  </footer>
</template>

<script>
export default { name: 'FooterSection' }
</script>
